// The server's rule (membership.ts normalizeTenantKey, and how role_key is
// made at boot): the first `.` becomes `-`, compared case-insensitively.
const normalizeTenantKey = (key: string) => key.replace(".", "-").toLowerCase();

/**
 * The tenant to start in: the first candidate key the user has, in order,
 * otherwise their first tenant. A candidate matches a tenant's `value` or its
 * `role_key`, since both are stored as the current tenant key.
 */
export const pickInitialTenant = (tenants: any[], candidates: unknown[]) => {
	for (const candidate of candidates) {
		if (typeof candidate !== "string" || !candidate) continue;
		const wanted = normalizeTenantKey(candidate);
		const found = tenants.find((tenant: any) =>
			[tenant?.value, tenant?.role_key].some(
				(key) => typeof key === "string" && normalizeTenantKey(key) === wanted
			)
		);
		if (found) return found;
	}
	return tenants[0] ?? null;
};
